import { Alert, Anchor, Text } from 'ui';
import { IconLock } from 'ui/Icons';

const Disclaimer = () => {
  return (
    <Alert icon={<IconLock />}>
      <Text fz={'sm'}>
        We’re serious about security. Learn more about our{' '}
        <Anchor
          href="https://support.givebacks.com/hc/en-us/articles/15303355814679-Is-Shop-to-Give-safe-What-does-it-do-with-my-data"
          target="_blank"
        >
          <Text span fz={12} c="cobalt" fw={600}>
            commitment
          </Text>
        </Anchor>{' '}
        to keep your data safe.
      </Text>
    </Alert>
  );
};

export { Disclaimer };
